export default class NewsDetail {
  constructor(el) {
    this.el = el;
    this.copyUrlBtn = null;
    this.init();
    this.initEvents();
  }
  init() {
    this.copyUrlBtn = this.el.querySelector(".share-copyUrl");
  }
  initEvents() {
    this.copyUrlBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.showPopup();
    });
  }
  showPopup() {
    const popup = document.querySelector(".share-copyUrl-popup");
    popup.style.display = "inline-block";
    setTimeout(() => {
      popup.style.display = "none";
    }, 4000);
    navigator.clipboard.writeText(window.location.href);
  }
}
